import DistressLine from "./DistressLine";
import EventPoint from "./EventPoint";
import LaneMarkingLine from "./LaneMarkingLine";

export default class DrawItems {
  distressLines: DistressLine[] = [];
  laneMarkingLines: LaneMarkingLine[] = [];
  eventPoints: EventPoint[] = [];
}
